/** 
 * AOS init 
 */

jQuery(document).ready(function ($) {
    if(BlockConfig.animations.active){
        AOS.init();
    }
});



// WEBPACK FOOTER //
// ./src/components/animations/script.js